<template>
	<div class="circuit-list-main">
		<v-btn
			@click="createCircuit"
			color="accent"
			dark
			elevation="0"
			x-large
			block=""
			>Crear circuito</v-btn
		>

		<filters @filterChanged="filterChanged"></filters>
		<div class="circuits-container">
			<circuits-container
				:filter="filter"
				class="circuits-container"
				@snackbar-event="$emit('snackbar-event', $event)"
				@loading="$emit('loading', $event)"
			></circuits-container>
		</div>
	</div>
</template>

<script>
	import CircuitsContainer from "./../../components/admin/CircuitsContainer";
	import Filters from "./../../components/admin/CircuitFilters";

	import axios from "axios";

	export default {
		name: "CircuitList",
		components: { CircuitsContainer, Filters },
		data: () => ({
			circuits: [],
			page: 1,
			count: 0,
			limit: 10,
			skip: 0,

			filter: {
				finished: false,
				notStarted: false,
			},
		}),

		methods: {
			//When the user wants to create a circuit, redirect to the correct view
			createCircuit() {
				this.$router.push({ name: "AdminCreateCircuit" });
			},
			filterChanged(filter) {
				this.filter = filter;
			},
		},
		async mounted() {
			try {
				await axios.post("/is-admin");
			} catch (error) {
				this.$router.push({ name: "AdminLogin" });
			}
		},
	};
</script>

<style lang="scss" scoped>
	.circuit-list-main {
		padding: 2em;

		.circuits-container {
			margin-top: 2em;
		}
	}
</style>
